import { z } from "zod";
import { listPreferencesSchema } from "@/components/listPreferences";
import type { ListPreferences } from "@/components/listPreferences";
import type {
    ProviderColumnFilter,
    ProviderSortingState,
} from "@/pages/Providers/types";

export const providerFiltersSchema = z.object({
    state: z.enum(["active", "inactive", "all"]),
    bc: z.enum(["all", "linked", "unlinked"]),
    conflicts: z.enum(["all", "pending", "blocking", "warning"]),
});
export const providerSortingSchema = z
    .array(
        z.object({
            id: z.enum(["name", "id", "bc_code", "tax_id"]),
            desc: z.boolean(),
        })
    )
    .length(1);
export const providerColumnsSchema = z
    .array(
        z.object({
            id: z.string(),
            value: z.union([z.string(), z.number(), z.boolean()]),
        })
    )
    .max(20);
export const providerViewSchema = z.object({
    search: z.string().max(500),
    filters: providerFiltersSchema,
    columnFilters: providerColumnsSchema,
    sorting: providerSortingSchema,
    preferences: listPreferencesSchema,
    pageSize: z
        .union([z.literal(20), z.literal(50), z.literal(100)])
        .default(20),
});
export interface ProviderViewState {
    search: string;
    filters: Record<string, string>;
    columnFilters: ProviderColumnFilter[];
    sorting: ProviderSortingState[];
    preferences: ListPreferences;
    pageSize: number;
}
